// src/components/PasswordChangeModal.js
import React, { useState } from 'react';
import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from 'firebase/auth';
import { auth } from '../services/firebase';
import CustomModal from './CustomModal';

const PasswordChangeModal = ({ isOpen, onClose, setNotification }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    const handleChangePassword = async (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            setNotification({ message: 'Die neuen Passwörter stimmen nicht überein.', type: 'error' });
            return;
        }
        if (newPassword.length < 6) {
            setNotification({ message: 'Das neue Passwort muss mindestens 6 Zeichen lang sein.', type: 'error' });
            return;
        }

        setIsSaving(true);
        const user = auth.currentUser;
        if (!user) {
            setNotification({ message: 'Fehler: Nicht authentifiziert.', type: 'error' });
            setIsSaving(false);
            return;
        }

        const credential = EmailAuthProvider.credential(user.email, currentPassword);

        try {
            await reauthenticateWithCredential(user, credential);
            await updatePassword(user, newPassword);
            setNotification({ message: 'Passwort erfolgreich geändert!', type: 'success' });
            onClose();
        } catch (error) {
            console.error("Fehler bei der Passwortänderung:", error);
            let errorMessage = 'Ein Fehler ist aufgetreten.';
            if (error.code === 'auth/wrong-password') {
                errorMessage = 'Das aktuelle Passwort ist falsch.';
            }
            setNotification({ message: `Fehler: ${errorMessage}`, type: 'error' });
        } finally {
            setIsSaving(false);
        }
    };

    if (!isOpen) return null;

    return (
        <CustomModal isOpen={isOpen} onClose={onClose}>
            <h2 className="text-2xl font-bold mb-6 text-center">Passwort ändern</h2>
            <form onSubmit={handleChangePassword} className="space-y-4">
                <div>
                    <label className="block text-sm font-medium mb-1" htmlFor="current-password">Aktuelles Passwort</label>
                    <input type="password" id="current-password" name="current-password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} className="w-full px-4 py-2 border rounded-lg" required />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1" htmlFor="new-password">Neues Passwort</label>
                    <input type="password" id="new-password" name="new-password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="w-full px-4 py-2 border rounded-lg" required />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1" htmlFor="confirm-password">Neues Passwort bestätigen</label>
                    <input type="password" id="confirm-password" name="confirm-password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="w-full px-4 py-2 border rounded-lg" required />
                </div>
                <div className="mt-6 flex justify-end space-x-3">
                    <button type="button" onClick={onClose} className="px-6 py-2 bg-gray-300 rounded-lg font-semibold">Abbrechen</button>
                    <button type="submit" disabled={isSaving} className={`px-6 py-2 rounded-lg text-white font-bold ${isSaving ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'}`}>
                        {isSaving ? 'Speichern...' : 'Passwort ändern'}
                    </button>
                </div>
            </form>
        </CustomModal>
    );
};

export default PasswordChangeModal;
